import React from 'react';
import { connect } from 'react-redux';

import DesktopNav from './desktop_nav.jsx';
import DesktopMenuItemComponent from './desktop.menu.menu_item_container.jsx';
import DesktopSubmenuItemComponent from './desktop.submenu.submenu_item_container.jsx';
import DesktopSubmenuDropdownComponent from './desktop.submenu_dropdown_container.jsx';
import DesktopSubmenuItemInTopLevelComponent from './desktop.menu.submenu_item_in_toplevel_container.jsx';

import { getIsUsingLegacyHeader } from 'zoomforth_codesbane_viewer/reducers/index.js';

import MobileNav from './mobile_nav_container.jsx';

import {
  getCurrentSubpage,
  getLastClickedSubmenuItemId,
  getOrderedVisibleMainMenuItems,
  getVisibleSubmenuItemsBySubpageId,
  getSocialLinks,
  getShouldShowSocialLinks,
  getRenderAsMobile,
  getHomeSubpage,
  getTranslationsIsEnabled,
  getTranslationsAppliedLanguages,
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  shouldHideMainNavigation,
  shouldShowSubmenuItemsInToplevel
} from 'zoomforth_codesbane_viewer/lib/navigation.js';

import {
  setTranslationsCurrentLanguageIso
} from 'zoomforth_codesbane_editor/action_creators/translations.js';


const mapStateToProps = (state) => {
  const socialLinks = getSocialLinks(state);
  const shouldShowSocialLinks = getShouldShowSocialLinks(state);
  const currentSubpage = getCurrentSubpage(state);
  const renderAsMobile = getRenderAsMobile(state);
  const lastClickedSubmenuItemId = getLastClickedSubmenuItemId(state);
  const homeSubpage = getHomeSubpage(state);

  const menuItems = getOrderedVisibleMainMenuItems(state);
  const submenuItemsBySubpageId = getVisibleSubmenuItemsBySubpageId(state);

  const currentSubmenuItems = submenuItemsBySubpageId ?  submenuItemsBySubpageId[currentSubpage.id] : [];
  const hideDesktopNavigation = shouldHideMainNavigation(menuItems, currentSubmenuItems, homeSubpage.id);
  const shouldShowSubmenuNavigationAsToplevel = shouldShowSubmenuItemsInToplevel(menuItems, currentSubmenuItems);

  var SubmenuItemComponent = DesktopSubmenuItemComponent;
  if (shouldShowSubmenuNavigationAsToplevel) {
    SubmenuItemComponent = DesktopSubmenuItemInTopLevelComponent;
  }

  const isUsingLegacyHeader = getIsUsingLegacyHeader(state);

  const isTranslationsEnabled = getTranslationsIsEnabled(state);
  const appliedLanguages = getTranslationsAppliedLanguages(state);
  const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);

  return {
    isTranslationsEnabled: isTranslationsEnabled && isUsingLegacyHeader,
    appliedLanguages,
    currentLanguageIso,
    defaultLanguageIso,
    renderAsMobile,
    socialLinks,
    shouldShowSocialLinks,
    shouldShowSubmenuNavigationAsToplevel,
    SubmenuItemComponent,
    currentSubpage,
    currentSubmenuItems,
    lastClickedSubmenuItemId,
    submenuItemsBySubpageId,
    menuItems,
    hideDesktopNavigation,
    isUsingLegacyHeader
  };
};


const mapDispatchToProps = (dispatch)=> {
  return {
    onLanguageChange: (iso)=> {
      dispatch(setTranslationsCurrentLanguageIso(iso));
    }
  };
};


const NavigationSwitcher = ({ hideDesktopNavigation, renderAsMobile, ...props })=> (
  renderAsMobile ?
    <MobileNav {...props} />
  : hideDesktopNavigation ?
    null
  :
    <DesktopNav
      SubmenuDropdownComponent={DesktopSubmenuDropdownComponent}
      MenuItemComponent={DesktopMenuItemComponent}
      {...props}
    />
);


export default connect(
  mapStateToProps,
  mapDispatchToProps

)(NavigationSwitcher);
